export default {
    type: 'locations',
    aliases: {
        camel: 'locations',
        singular: 'Location',
        plural: 'Locations',
        lowerSingular: 'location',
        lowerPlural: 'locations',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'location-modules',
                localKey: 'locationId',
                foreignKey: 'moduleId'
            }
        },
    },
    publishable: true,
    adminSection: 'about',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerLocationRecord',
            loader: () => import('./AdministerLocationRecord')
        },
        // webRecord: {
        //     name: 'DisplayLocationRecord',
        //     loader: () => import('./DisplayLocationRecord')
        // },
        webCollectionItem: {
            name: 'LocationPoster',
            loader: () => import('./LocationPoster')
        }
    },
};
